import { AfterViewInit, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthService } from './core/services/auth/auth.service';
import { initFlowbite } from 'flowbite';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'AuroDoc';
  isLoggedIn$: Observable<boolean> | undefined;
  maintenanceMode = environment.maintenance && environment.production;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private authService: AuthService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.isLoggedIn$ = this.authService.isLoggedIn;
    const lang = JSON.parse(localStorage.getItem('LANGUAGE') ?? '')?.code ?? 'es';
    this.translate.setDefaultLang(lang);
    this.translate.use(lang);

    this.updateTitle();

    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.updateTitle();
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      initFlowbite();
    }, 1000);
  }

  getChild(activatedRoute: ActivatedRoute): any {
    if (activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
  }

  private updateTitle(): void {
    let currentRoute = this.activatedRoute.root;
    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
    }

    currentRoute.data.subscribe((data: { title?: string }) => {
      if (data.title) {
        this.translate.get(data.title).subscribe(translatedTitle => {
          this.titleService.setTitle('AuroDoc - ' + translatedTitle);
        });
      } else {
        this.titleService.setTitle('AuroDoc');
      }
    });
  }
}
